<template>
  <div class="bg">
    <div class="container">
      <img src="../assets/logo.png" class="logo" />
      <form class="box-container" @submit.prevent="submit" v-if="!$store.state.coach">
        <input type="email" placeholder="Email" v-model="email" required/>
        <input type="password" placeholder="Password" v-model="password" />
        <p v-if="error" class="error-msg">{{ error }}</p>
        <button type="submit">Log in</button>
        <a @click="$router.push('/forgot')" class="forgot-link">Forgot Password?</a>
      </form>
      <!-- <div class="signup">
        Don't have an account?
        <a @click="$router.push('/signup')">Sign Up</a>
      </div> -->
    </div>
  </div>
</template>

<script>
import store from "../store";
export default {
  data() {
    return {
      error: "",
      email: "",
      password: ""
    };
  },
  methods: {
    submit() {
      const credentials = {
        email: this.email,
        password: this.password
      };
      this.$store.dispatch("login", credentials).then((response) => {

        this.error = [];
        if(typeof response !== 'undefined') {
          if(response.code == 'auth/user-not-found') {
            this.error = 'Account is not active, please email bobby@imlcacoaches.com to activate.';
          } else if(response.code == 'auth/wrong-password') {
            this.error = 'Incorrect password, please try again. Please email bobby@imlcacoaches.com if you need additional assistance';
          } else if(response.code == 'auth/invalid-email') {
            this.error = 'Account does not exist, please email bobby@imlcacoaches.com to get your account setup';
          }else{
            this.error = 'Incorrect password, please try again. Please email bobby@imlcacoaches.com if you need additional assistance';
          }
        } 
        else {
          this.$router.push("/athletes");
        }
      
      });
    }
  },
  beforeRouteEnter(to, from, next) {
    if (!store.state.coach) {
      next();
    } else {
      next("/athletes");
    }
  }
};
</script>

<style lang="scss" scoped>
p.error-msg {
    border: 1px solid #cf202a;
    padding: 10px;
}

.bg {
  background: url("../assets/bg.png");
  background-size: cover;
  width: 100%;
}
.container {
  max-width: 747px;
  margin: 0 auto;
  position: absolute;
  left: 0;
  right: 0;
  top: 50%;
  transform: translateY(-50%);
  padding: 28px;
  box-shadow: 10px 10px 10px rgba(0, 0, 0, 0.39);
}

img.logo {
  width: 100%;
}

form.box-container {
  padding: 50px 30px 20px;
}

form.box-container input {
  font-family: Helvetica Neue, Helvetica, Arial, sans-serif;
  width: 100%;
  border: none;
  border-bottom: 1px solid #707070;
  padding: 10px 5px;
  margin-bottom: 30px;
  font-size: 24px;
  line-height: 28px;
  outline: none;
  color: #707070;
}
form.box-container button[type="submit"] {
  font-family: Helvetica Neue, Helvetica, Arial, sans-serif;
  background: #005fa8;
  width: 226px;
  padding: 8px;
  color: #fff;
  border: none;
  font-size: 28px;
  display: block;
  margin: 0 auto;
  margin-top: 50px;
  cursor: pointer;
  border-radius: 5px;
  box-shadow: 1px 1px 3px 0px rgba(0, 0, 0, 0.5);
}
form.box-container .forgot-link {
  color: #0063ae;
  text-align: center;
  display: block;
  text-decoration: none;
  padding-top: 20px;
  font-size: 21px;
}
.signup {
  color: #707070;
  text-align: center;
  display: block;
  text-decoration: none;
  font-size: 21px;
  padding-top: 50px;
}

.signup a {
  color: #0063ae;
  text-decoration: none;
}
</style>
